import { hashCode } from "@repo/utils";

export const getSectionWtClass = (
  sectionId,
  workTypeId,
) => (
  `wT${hashCode(sectionId)}-${hashCode(workTypeId)}`
)